import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { AircashMarketplaceBonusLabel } from "@common/constants/BonusConstant";
import { useFixBody } from "@state/hooks/shared";

export default function UseMarketplaceBonusConfirmPopup(props: {
	hidePopup: () => void;
	sendConfirmation: (value: boolean) => Promise<void>;
}) {
	const { t } = useTranslation("my-bonuses");

	const rootStore = useRootAppStore();

	const welcomeStore = rootStore.welcomeStore;

	useFixBody(true, welcomeStore.isUseBonusConfirmActive);

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					<span>{AircashMarketplaceBonusLabel}</span>
				</div>
				<div className="popup__body">
					<span>{t("MARKETPLACE_BONUS.CONFIRMATION_TEXT")}</span>
				</div>
				<div className="popup__footer">
					<Button
						className="btn--sml btn--block btn--primary--inverted"
						btnText={t("COMMON.CANCEL_BUTTON")}
						onClick={async () => {
							if (!location.pathname.includes("my-bonuses")) {
								await props.sendConfirmation(true);
							}
							props.hidePopup();
						}}
					/>

					<Button
						className="btn--sml btn--block btn--primary"
						btnText={t("COMMON.APPLY_BUTTON")}
						onClick={async () => {
							props.hidePopup();

							await props.sendConfirmation(false);
						}}
					/>
				</div>
			</div>
		</div>
	);
}
